import { render, staticRenderFns } from "./CreatePartnerModal.vue?vue&type=template&id=1fecb5f4&"
import script from "./CreatePartnerModal.vue?vue&type=script&lang=js&"
export * from "./CreatePartnerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports